import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextIndentLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="text-indent-left"><path d="M9.75 5.75H21.25M9.75 18.25H21.25M9.75 12H21.25M4.5 12L3.5 12M2.75 10V14L5.75 12L2.75 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTextIndentLeft;
